import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useAxios from '../axios/useAxios';
import Confetti from 'react-confetti';
import checkcircle from '../styles/img/check-circle-svgrepo-com.svg';
import persovite from '../styles/img/persovitesse.svg';
import InstallPWA from '../components/InstallPwa';

const GiftScreen = () => {
  const navigate = useNavigate();
  const axiosInstance = useAxios();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const { cartItems } = useSelector((state) => state.cart);
  const { store } = useSelector((state) => state.store);
  const [confettiss, setConfetti] = useState(true);
  const pwa = 'standalone' in window.navigator && window.navigator.standalone;
  const [installationPopup, setInstallationPopup] = useState(false);
  
  useEffect(() => {
    setTimeout(() => {
      setConfetti(false);
    }, 2000);
  }, []);

  return (
    <div className="pt-40 w-full h-full giftscreen_contenaire">
      {/* <div className="blurback active"></div> */}
      {/* {user.loading ? (
                <div>Loading...</div>
            ) : ( */}
      <>
        <Confetti
          className="block confettis"
          width={window.innerWidth}
          height={window.innerHeight}
          recycle={false}
          numberOfPieces={500}
          gravity={0.15}
          color={[
            '#E1FF26',
            '#FFCF26',
            '#FFDB26',
            '#FFB426',
            '#FF9A26',
            '#FF73B4',
            '#FF68E9',
            '#E1FF4B',
            '#B3FF26',
            '#A4FF9E',
            '#9DFF33',
            '#D7FF26',
            '#FFEB26',
            '#FFD826',
            '#FFAF26',
            '#FF7738',
          ]}
        />

        <div className="popupfinalisation">
          <div className="flex h-20 align-center justify-center">
            <strong>Félicitation !</strong>{' '}
            <img src={checkcircle} alt="" srcSet="" />
          </div>

          <div className="text">
            <p>Tu as finalisé le parcours pikkopay !</p>
          </div>
          <div className="persovite flex">
            <img src={persovite} alt="" />
            <p>Tu as fait ... minutes </p>
          </div>
          <p>En moyenne les clients ont mis en période d’affluence 11min57s</p>
          {pwa ? (
            <div className="btn payer">
              <button
                className="w-full"
                onClick={() => navigate(`/ordersuccess/${cartItems._id}`)}
              >
                Continuer
              </button>
            </div>
          ) : (
            <div className="btn flex w-full">
              <button
                className="w-full"
                onClick={() => navigate(`/ordersuccess/${cartItems._id}`)}
              >
                Continuer
              </button>
              <button className="payer">
                <InstallPWA />
              </button>
            </div>
          )}
        </div>
      </>
      {/* )} */}
    </div>
  );
};

export default GiftScreen;
